import { useState } from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the date picker styles
import './edit-leave.css'; // Custom CSS for additional styling if needed
import { FaEdit } from "react-icons/fa";

export default function EditLeave() {
  const [leavetype, setleavetype] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [counter1, setCounter1] = useState(0);
  const [counter2, setCounter2] = useState(0);
  const [reason, setReason] = useState('');

  const leavetypeOptions = [
    { value: 'sick', label: 'Sick Leave' },
    { value: 'vacation', label: 'Vacation Leave' },
    { value: 'personal', label: 'Personal Leave' },
    // Add more options as needed
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Selected Leave Type:', leavetype);
    console.log('Start Date:', startDate);
    console.log('End Date:', endDate);
    console.log('Counter 1:', counter1);
    console.log('Counter 2:', counter2);
    console.log('Leave Reason:', reason);
  };

  return (
    <div className="edit-leave-container">
      <h1 className='edit-leave-title'><FaEdit /> Edit Leave</h1>
      <hr />
      <div className='edit-leave-content'>
        <Form onSubmit={handleSubmit}>
          <Form.Group as={Col} xs={12} md={6} controlId="formGridRole" className="form-group">
            <Form.Label className="form-label">Leave Type <span className="required-asterisk">*</span></Form.Label>
            <Select
              options={leavetypeOptions}
              value={leavetype}
              onChange={(selectedOption) => setleavetype(selectedOption)}
              placeholder="--Select Leave--"
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} md={6} controlId="formStartDate" className="form-group">
            <Form.Label className="form-label">Start Date <span className="required-asterisk">*</span></Form.Label>
            <div className="react-datepicker-wrapper">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                placeholderText="MM/dd/yyyy"
                className="react-datepicker-input"
                dateFormat="MM/dd/yyyy"
              />
            </div>
          </Form.Group>

          <Form.Group as={Col} xs={12} md={6} controlId="formEndDate" className="form-group">
            <Form.Label className="form-label">End Date <span className="required-asterisk">*</span></Form.Label>
            <div className="react-datepicker-wrapper">
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                placeholderText="MM/dd/yyyy"
                className="react-datepicker-input"
                dateFormat="MM/dd/yyyy"
              />
            </div>
          </Form.Group>

          <Form.Group as={Col} xs={12} md={6} controlId="formCounter1" className="form-group">
            <Form.Label className="form-label">Applied Duration <span className="required-asterisk">*</span></Form.Label>
            <Form.Control
              type="number"
              value={counter1}
              onChange={(e) => setCounter1(Number(e.target.value))}
              className="form-control"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} md={6} controlId="formCounter2" className="form-group">
            <Form.Label className="form-label">Approve Duration <span className="required-asterisk">*</span></Form.Label>
            <Form.Control
              type="number"
              value={counter2}
              onChange={(e) => setCounter2(Number(e.target.value))}
              className="form-control"
            />
          </Form.Group>

          <Form.Group as={Col} xs={12} controlId="formLeaveReason" className="form-group">
            <Form.Label className="form-label">Leave Reason <span className="required-asterisk">*</span></Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for leave"
              className="form-control expandable-textarea"
            />
          </Form.Group>

          <Button type="submit" className="approve-btn">
            Submit
          </Button>
        </Form>
      </div>
    </div>
  );
}
